import Provider from '@/enums/Provider';
import IDescription from '@/interfaces/IDescription';
import IImage from '@/interfaces/IImage';
import UrlTypes from '@/enums/UrlTypes';
import { useNotificationStore } from '@/store/notificationStore';
import { extractImagesFromHtml } from '@/helpers/images/extractImagesFromHtml';
import { extractIOProductDescription } from './extractIOProductDescription';
import { extractERSProductDescription } from './extractERSProductDescription';
import { extractKBSProductDescription } from './extractKBSProductDescription';

export function extractProductDescription(
    htmlSource: string,
    pathname: string,
    provider: Provider
): IDescription {
    let descriptionHtml = '';
    const images: IImage[] = [];
    const notification = useNotificationStore();

    switch (provider) {
        case Provider.KBS:
            descriptionHtml = extractKBSProductDescription(htmlSource);
            break;
        case Provider.IO:
            descriptionHtml = extractIOProductDescription(htmlSource);
            break;
        case Provider.ERS:
            descriptionHtml = extractERSProductDescription(htmlSource);
            break;
        default:
            notification.addErrorNotification(
                `Unsupported provider: ${provider} for URL: ${pathname}`
            );
            break;
    }

    if (descriptionHtml) {
        images.push(
            ...extractImagesFromHtml(
                descriptionHtml,
                pathname,
                UrlTypes.PRODUCT_DESCRIPTION
            )
        );
    }

    return { pathname, descriptionHtml, images };
}
